/**
 * フロントエンドのランタイム設定。
 * 本番では SSM Parameter Store から取得した値を CI で `.env.production` 等に書き出し、
 * Vite のビルド時に VITE_API_BASE_URL として埋め込む前提とする。
 * (frontend repository から直接 AWS SDK で SSM を引かない方針)
 */

interface AppEnv {
  apiBaseUrl: string;
  logoFrontendUrl: string;
  envName: 'dev' | 'prd' | 'local';
}

function readEnv(): AppEnv {
  const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;
  if (typeof apiBaseUrl !== 'string' || apiBaseUrl.length === 0) {
    throw new Error(
      'VITE_API_BASE_URL が未設定です。CI で SSM /mail_retention/{env}/backend/api-url を書き出してください。',
    );
  }

  const rawEnvName = import.meta.env.VITE_ENV_NAME ?? 'local';
  if (rawEnvName !== 'dev' && rawEnvName !== 'prd' && rawEnvName !== 'local') {
    throw new Error(`未対応の VITE_ENV_NAME: ${rawEnvName}`);
  }

  const logoFrontendUrl =
    import.meta.env.VITE_LOGO_FRONTEND_URL || 'https://mangamillion.shueisha.co.jp/';

  return { apiBaseUrl, logoFrontendUrl, envName: rawEnvName };
}

export const appEnv: AppEnv = readEnv();
